import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _objectWithoutProperties from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectWithoutProperties";
import _classCallCheck from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Preset
import { preset as Preset } from "../../presets/default"; // Utilities

import { consoleWarn } from "../../util/console";
import { mergeDeep } from "../../util/helpers";
import { Service } from "../service";
export var Presets = /*#__PURE__*/function (_Service) {
  _inherits(Presets, _Service);

  var _super = _createSuper(Presets);

  function Presets(parentPreset, parent) {
    var _this;

    _classCallCheck(this, Presets);

    _this = _super.call(this); // The default preset

    var defaultPreset = mergeDeep({}, Preset); // The user provided preset

    var userPreset = parent.userPreset; // The user provided global preset

    var _userPreset$preset = userPreset.preset,
        globalPreset = _userPreset$preset === void 0 ? {} : _userPreset$preset,
        preset = _objectWithoutProperties(userPreset, ["preset"]);

    if (globalPreset.preset != null) {
      consoleWarn('Global presets do not support the **preset** option, it can be safely omitted');
    }

    parent.preset = mergeDeep(mergeDeep(defaultPreset, globalPreset), preset);
    return _this;
  }

  return Presets;
}(Service);
Presets.property = 'presets';